export const SORTING_ORDER = {
  ascending: 'asc',
  descending: 'desc',
};
